
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import AddForm from "./pages/Tasks/AddEdit/AddForm";
import EditForm from "./pages/Tasks/AddEdit/EditForm";
import TaskBody from "./pages/Tasks/TaskBody";

function App() {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<TaskBody/>}/>
        <Route path="/add-task" element={<AddForm/>}/>
        <Route path="/edit-task/:taskId" element={<EditForm/>}/>
      </Routes>
    </Router>
  );
}

export default App;
